class QuantityInput extends HTMLElement {
    constructor() {
        super();

        this.setup();
    }

    connectedCallback() {
        this.setup();
    }

    setup() {
        // Don't run twice - fixes issues with custom elements appended to the DOM
        if (this._instantiated) return;

        this.input = this.querySelector("[data-quantity-value]");
        this.incrementButton = this.querySelector("[data-quantity-increment]");
        this.decrementButton = this.querySelector("[data-quantity-decrement]");

        if (!this.input) {
            return;
        }

        this?.incrementButton?.addEventListener(
            "click",
            this.increment.bind(this),
        );

        this?.decrementButton?.addEventListener(
            "click",
            this.decrement.bind(this),
        );

        // Complete instantiation
        this._instantiated = true;
    }

    increment() {
        const step = parseFloat(this.input.getAttribute("step")) || 1;
        const max = parseFloat(this.input.getAttribute("max")) || Infinity;

        let currentValue = parseFloat(this.input.value) || 0;

        if (currentValue < max) {
            this.input.value = currentValue + step;
            this.triggerInputEvents();
        }
    }

    decrement() {
        const step = parseFloat(this.input.getAttribute("step")) || 1;
        const min = parseFloat(this.input.getAttribute("min")) || 0;

        let currentValue = parseFloat(this.input.value) || 0;

        if (currentValue > min) {
            this.input.value = currentValue - step;
            this.triggerInputEvents();
        }
    }

    triggerInputEvents() {
        this.input.dispatchEvent(new Event("change", { bubbles: true }));
        this.input.dispatchEvent(new Event("input", { bubbles: true }));
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue !== newValue) {
            this.init();
        }
    }

    static get observedAttributes() {
        return ["min", "max", "step"];
    }
}

customElements.define("quantity-input", QuantityInput);
